module.exports = __webpack_public_path__ + "img/6.3b5a61f6.jpg";